module.exports = __webpack_public_path__ + "img/title-bg.48347051.png";